/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useMemo } from 'react';
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
  Input,
} from 'reactstrap';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import SpinnerCircles from '../../../Spinner/SpinerCircles';
import './portConfigModal.css';
import getObiData from '../../../../containers/epikBoxes/helpers';
import { getEpikBoxData, setPortValues, setSilenceDetect } from '../../../../actions/EpikBoxes';
import { sortingEven, sortingOdd } from '../../constants';
import { changeAction } from '../../../../actions/BoxSessionLogging';
import WarningModal from '../../../WarningModal';
import Toggle from '../../../Toggle';
import InfoPopup from '../../../InfoPopup';

// eslint-disable-next-line no-shadow
const PortConfigModal = ({
  isOpen,
  isClose,
  settings,
  // eslint-disable-next-line no-shadow
  setPortValues,
  setSilenceDetect,
  port,
  boxDetails,
  refresh,
  settingsValidationRules,
  changeAction,
  getEpikBoxData,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [count, setCount] = useState(10);
  const [start, setStart] = useState(false);
  const [data, setData] = useState([]);
  const [loadApply, setLoadApply] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [valueChange, setValueChange] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const token = localStorage.getItem('jwtToken');
  const sortFunc = (a, b) => {
    const portIdx = port.boxPortNumber.split(' ')[1];
    const sortingType = portIdx % 2 === 0 ? sortingEven : sortingOdd;
    return sortingType.indexOf(a.id) - sortingType.indexOf(b.id);
  };

  useEffect(() => {
    setShowModal(isOpen);
  }, [isOpen]);

  const fieldsValidation = array => {
    const isAllFieldsValid = array.every(item => item.dbValue !== '' && item.dbValue !== null);
    if (isAllFieldsValid) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const validateRegX = (value, regEx) => {
    if (!regEx) return false;
    if (!value) return false;
    const regExS = new RegExp(regEx);
    return regExS.test(value);
  };

  useEffect(() => {
    settings?.length && settings.sort(sortFunc);
    const newArr = [];
    settings?.length &&
      settings.forEach(item => {
        const nameOfInterest = item.name.split('.');
        settingsValidationRules?.forEach(i => {
          if (i.name === nameOfInterest[nameOfInterest.length - 1]) {
            const itemData = {
              ...item,
              ...i,
              dbValue: i.type === "toggle" ? "Medium" : (item.dbValue ? item.dbValue : ''),
              value: item.value ? item.value : '',
              isValid: (i.type === "toggle" || validateRegX(item?.dbValue, i?.regEx)) ? true : false,
            };
            newArr.push(itemData);
          }
        });
      });
    fieldsValidation(newArr);
    setData(newArr);
  }, [settings]);

  useEffect(() => {
    if (data[6]?.dbValue === null || data[6]?.dbValue === '') {
      const newData = [...data];
      newData[6] = { ...newData[6], dbValue: 'inband', isValid: true };
      setData(newData);
      fieldsValidation(newData);
    } else if (data[6]?.dbValue) {
      const newData = [...data];
      newData[6] = { ...newData[6], isValid: true };
      setData(newData);
      fieldsValidation(newData);
    }
  }, [data]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (start && count > 1) {
      const timer = setTimeout(() => setCount(count - 1), 1000);
      if (count - 1 === 1) {
        setTimeout(() => {
          setCount(10);
          setIsLoading(false);
        }, 1000);
      }
      return () => {
        clearTimeout(timer);
      };
    }
    setStart(false);
  }, [count, start]);

  const handleChange = e => {
    if (e.target) {
      const { name, value } = e.target;
      data[name] = { ...data[name], dbValue: value, useDefault: value === '' };
      setData([...data]);
    } else {
      const findIndex = data?.findIndex(item => item.name.toLowerCase().includes('silence'));
      data[findIndex] = { ...data[findIndex], dbValue: !e ? 'Low' : 'Medium' };
      setData([...data]);
    }
  };
  const handleBlur = (e, validate) => {
    const { name, value } = e.target;
    const regEx = new RegExp(validate);
    if (value.length >= 1 && !regEx.test(value)) {
      toast.error('Invalid entry');
      setIsValid(false);
      data[name] = { ...data[name], isValid: false };
      setData([...data]);
    } else if (value.length >= 1 && regEx.test(value)) {
      data[name] = { ...data[name], dbValue: value, useDefault: value === '', isValid: true };
      setData([...data]);
      setIsValid(true);
    }
  };

  const isEmpty = value => {
    return (
      // null or undefined
      value == null ||
      // has length and it's zero
      (value.hasOwnProperty('length') && value.length === 0) ||
      // is an Object and has no keys
      (value.constructor === Object && Object.keys(value).length === 0)
    );
  };

  const onApplyButton = () => {
    const anyFieldEmpty = data.some(item => item.dbValue === '');
    if (anyFieldEmpty) return toast.error('Please fill all fields');

    const everyThingValid = data.every(item => item.isValid);
    if (!everyThingValid) return toast.error('Please fill valid data in fields');



    setConfirmation(true)
  }

  const onApply = async () => {
    setConfirmation(false);
    const dataSettings = data;
    setIsLoading(true);
    setLoadApply(true);
    // const settingsOfInterest = data.map(item => {
    //   const itemOfInterest = { ...item };
    //   return { ...itemOfInterest };
    // });
    const obi = getObiData(port.boxPortNumber, boxDetails);

    let emptyAlert = false;
    dataSettings.forEach(item => {
      return isEmpty(item.dbValue) && (emptyAlert = true);
    });
    if (!emptyAlert) {
      const findIndex = dataSettings?.findIndex(item =>
        item.name.toLowerCase().includes('silence'),
      );
      const portIdx = port.boxPortNumber.split(' ')[1];
      const portNum = portIdx % 2 === 0 ? 2 : 1;
      const toggle = dataSettings[findIndex].dbValue === 'Low' ? 'enable' : 'disable';

      const silenceDetact = await setSilenceDetect(token, obi._id, portNum, toggle);

      if (!silenceDetact) {
        dataSettings[findIndex] = {
          ...dataSettings[findIndex],
          dbValue: dataSettings[findIndex].dbValue === 'Low' ? 'Medium' : 'Low',
        };
      }
      const body = {
        device: obi.deviceId,
        settings: { settings: dataSettings },
      };
      const portResStatus = await setPortValues(token, obi._id, body);
      if (portResStatus) {
        await changeAction('Port configuration values changed');
      }
      await getEpikBoxData(token, boxDetails._id);
      isClose();
      setLoadApply(false);
      setIsLoading(false);
    }
  };

  const itemsName = item => {
    if (item.name === 'OnHookTipRingVoltage') return 'Onhook Volts';
    if (item.name === 'DTMFMethod') return 'DTMF Method';
    if (item.name === 'ChannelRxGain') return 'RX Gain';
    if (item.name === 'ChannelTxGain') return 'TX Gain';
    if (item.name === 'DTMFDetectMinLength') return 'DTMF Detect Length';
    if (item.name === 'OffHookCurrentMax') return 'Offhook Current';
    if (item.name === 'DTMFDetectMinGap') return 'DTMF Detect Gap';
    if (item.name === 'DTMFPlaybackLevel') return 'DTMF Playback Level';
    if (item.name === 'RingVoltage') return 'Ring Voltage';
    if (item.name === 'DigitMapShortTimer') return 'Digit Map Short Timer';
    if (item.name === 'SilenceDetectSensitivity') return 'Silence Detect';
    return item.name;
  };

  const renderItem = (item, ind) => {
    if (item.type === 'dropdown') {
      return (
        <Input
          disabled={isLoading}
          type="select"
          name={ind}
          onChange={ev => handleChange(ev, item.regEx)}
          onBlur={ev => handleBlur(ev, item.regEx)}
        >
          {item.options.map(el => (
            <option key={el} value={el} selected={item.dbValue?.toLowerCase() === el.toLowerCase()}>
              {el}
            </option>
          ))}
        </Input>
      );
    }
    if (item.type === 'toggle') {
      return (
        <Toggle
          left="Med"
          right="Low"
          value={item.dbValue === 'Low'}
          onToggle={value => handleChange(value)}
        />
      );
    }
    return (
      <Input
        disabled={isLoading}
        name={ind}
        value={item.dbValue}
        onChange={ev => handleChange(ev, item.regEx)}
        onBlur={ev => handleBlur(ev, item.regEx)}
        valid={item.dbValue.length > 0 && item.isValid}
      />
    );
  };
  return (
    <Modal isOpen={showModal}>
      <ModalHeader>Port Configuration</ModalHeader>
      <ModalBody>
        <Row className="mb-2">
          <Col />
          <Col>
            <h1 className="font-weight-bold">Database Settings</h1>
          </Col>
          <Col>
            <h1 className="font-weight-bold">Device Settings</h1>
          </Col>
        </Row>
        {data?.map((item, ind) => {
          return (
            <Row className="mb-3 d-flex justify-content-center align-items-center">
              <Col className="d-flex">
                <Label title={item.tooltip}>{itemsName(item)}</Label>
                <sup>
                  <InfoPopup id={item?.name} text={item?.tooltip} />
                </sup>
              </Col>
              <Col className="d-flex align-items-center justify-content-center">
                {renderItem(item, ind)}
              </Col>
              <Col>
                <Label className="d-flex align-items-center justify-content-center">
                  {item.value}
                </Label>
              </Col>
            </Row>
          );
        })}
      </ModalBody>
      <ModalFooter className="port-config-footer">
        <div className="btn-row1">
          <Button
            color="primary"
            disabled={isLoading}
            onClick={() => {
              setIsLoading(true);
              refresh();
              setStart(true);
            }}
          >
            Refresh {count !== 10 && count !== 1 ? `in ${count}` : ''}
          </Button>
          <Button
            disabled={isLoading}
            color="primary"
            onClick={onApplyButton}
          >
            {loadApply ? <SpinnerCircles /> : 'Apply'}
          </Button>
        </div>
        <Button outline color="secondary" onClick={isClose}>
          Close
        </Button>
      </ModalFooter>
      <WarningModal
        isOpen={confirmation}
        onConfirm={() => {
          onApply();
        }}
        title="Warning"
        onCancel={() => setConfirmation(false)}
        body={
          'The ATA needs to be rebooted to configure the port and the affected ports will be offline for 3 minutes. Are you sure you want to proceed?'
        }
      />
    </Modal>
  );
};

const mapDispatchToProps = dispatch => ({
  setPortValues: (token, obiId, body) => dispatch(setPortValues(token, obiId, body)),
  setSilenceDetect: (token, obiId, portNum, toggle) =>
    dispatch(setSilenceDetect(token, obiId, portNum, toggle)),
  changeAction: description => dispatch(changeAction(description)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
});

export default connect(
  null,
  mapDispatchToProps,
)(PortConfigModal);
